import { jsonApiVuex } from '@common/store/json-api-vuex';

export const amsRedirectRule = jsonApiVuex(
  'ams/redirect-rule',
  {
    /*getters*/
  },
  {}
);
